import { render, staticRenderFns } from "./HiPageColumn.vue?vue&type=template&id=b2d3645e&scoped=true&"
import script from "./HiPageColumn.vue?vue&type=script&lang=js&"
export * from "./HiPageColumn.vue?vue&type=script&lang=js&"
import style0 from "./HiPageColumn.vue?vue&type=style&index=0&id=b2d3645e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d3645e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
